/**
 * EVO-263: colores hermanos de un configurable.
 *
 * En Casaideas cada COLOR es un configurable aparte (los configurables usan
 * `talla` como unico super attribute y `color` es un atributo a nivel de
 * producto), por lo que los colores NO llegan en `variants`. El link type
 * `associated_products` de Magento —expuesto por el edge— es el que agrupa a los
 * hermanos de color.
 *
 * `swatch_image_data` existe porque el `swatch_image: String` del core devuelve
 * solo el filename; este trae la URL resuelta del rol `swatch_image` (la foto de
 * fondo blanco, no la ambientada).
 *
 * `associated_products_title` es un atributo del PRODUCTO (scope store view)
 * con el titulo del bloque; viaja junto al resto del fragmento principal (PDP y
 * PLP) y encabeza la cascada titulo del producto -> `associated_products_default_title`
 * del storeConfig -> texto traducido.
 *
 * Contrato fijo, identico en Magento / edge / pwa: no alterar la sub-seleccion.
 */
export const AssociatedProductsFragment = /* GraphQL */ `
    associated_products_title
    associated_products {
        __typename
        id
        uid
        name
        sku
        url_key
        stock_status
        swatch_image_data {
            url
            label
        }
        small_image {
            url
        }
        thumbnail {
            url
        }
        price_range {
            minimum_price {
                final_price {
                    value
                    currency
                }
                regular_price {
                    value
                    currency
                }
                discount {
                    amount_off
                }
            }
        }
    }
`
